import { IRoutePricePreview } from "./components/RoutePriceComponent";

export const getRouteTransactionMonthAndYear = () => {
  const today = new Date();

  // If today is 1st, 2nd, or 3rd of the month, go back 2 months.
  // Because route transaction is generated every 4th of the month,
  // we need to get the last month route transaction
  const monthOffset = today.getDate() < 4 ? 2 : 1;

  // Move the date back by the desired number of months
  today.setMonth(today.getMonth() - monthOffset);

  return {
    month: today.getMonth() + 1, // JavaScript month is 0-based
    year: today.getFullYear(),
  };
};

export const calculateTotal = (entry?: IRoutePricePreview) =>
  (entry?.baseAmount ?? 0) +
  (entry?.adjustmentAmount ?? 0) +
  (entry?.busAssistantIncentive ?? 0) +
  (entry?.additionalIncentive ?? 0) +
  (entry?.schoolIncentive ?? 0);
